import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import { DEFAULT_LANGUAGE } from '../config/constants';

moment.locale(DEFAULT_LANGUAGE);

i18n.use(initReactI18next).init({
	resources: {
		is: {
			translation: require('../config/is.json'),
		},
		en: {
			translation: require('../config/en.json'),
		},
	},
	lng: DEFAULT_LANGUAGE,
	fallbackLng: 'is',
	keySeparator: '.',
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
